const penyimpanan = window.localStorage;
export default {
    ambilDataSettingFont({ commit }){
        const strData       = penyimpanan.getItem("dataSetting");
        if(strData) {
            const objData           = JSON.parse(strData);
            if(Object.keys(objData).length > 0) {
                const names         = objData.namaAlmarhum ;
                const fontsize      = objData.fontSize ;
                const fontname      = objData.fontName ;
                const kataganti     = objData.kataganti ;
                const panjangData   = names.length ;
                const namaAlmarhum  = [];
                if(panjangData > 0){
                    for(let i = 0; i<panjangData; i++) {
                        namaAlmarhum.push(names[i])
                    }
                }
                return new Promise(function(resolve, reject){
                    try {
                        commit('SET_NAMAALMARHUM', namaAlmarhum);
                        if(fontsize) {
                            commit('SET_FONTSIZE', fontsize) ;
                        }
                        if(kataganti) {
                            commit('SET_KATAGANTI', kataganti) ;
                        }
                        if(fontname) {
                            commit('SET_FONTNAME', fontname) ;
                        }
                        resolve(objData);                         
                    } catch (error) {
                        reject(error);
                    }                       
                })
            } // Akhir dari if(Object.keys(objData).length > 0)
        } // Akhir dari if(strData.length > 0)
    },
    simpanDataSettingFont({ commit }, credentials){
        return new Promise(function(resolve, reject){
            const data = JSON.stringify(credentials) ;
            try {
                penyimpanan.setItem("dataSetting", data);
                commit('SET_SETTING', credentials);
                resolve(true) ;
            }
            catch(err) {
                reject(err);
            }
        })
    }
}